import queryString from 'query-string'
import { useEffect, useState } from 'react'
import { PaginationType } from '@/types/table'
import { DanhSachThongBao } from '@/types/danh-sach-thong-bao'
import { getCountThongBao, getListThongBao } from '@/services/danh-sach-thong-bao'
import { useAppSelector } from '@/state/hooks'
import { useDispatch } from 'react-redux'
import { MESSAGE } from '@/constants/message'
import { notification } from '@greenglobal/greencore.fe.common'
import { setDataCount } from '@/reducers/notification'

const useNotification = () => {
  const defaultSearch = {
    page: 1,
    limit: 5
  }
  const [list, setList] = useState<PaginationType<DanhSachThongBao.Types>>()
  const [isLoadingNoti, setIsLoadingNoti] = useState<boolean>(true)
  const { user } = useAppSelector((state) => state?.auth)
  const donViId = user?.id
  const dispatch = useDispatch()

  const handleGetList = async () => {
    setIsLoadingNoti(true)

    try {
      const response = await getListThongBao(donViId, queryString.stringify(defaultSearch))

      if (response) {
        setList(response.data)
      }
    } catch (_) {
    } finally {
      setIsLoadingNoti(false)
    }
  }

  const handleCountNoti = async () => {
    try {
      const response = await getCountThongBao(donViId)

      if (response) {
        dispatch(setDataCount(response?.data?.data))
      }
    } catch (err: any) {
      notification({
        message: err?.response?.data?.detail || MESSAGE.ERROR_SYSTEM,
        type: 'error'
      })
    } finally {
    }
  }

  useEffect(() => {
    if (donViId) {
      // handleGetList()
      handleCountNoti()
    }
  }, [donViId])

  return {
    list,
    handleGetList,
    isLoadingNoti
  }
}

export default useNotification
